import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';

import { IcView16Icon } from '@gem/icons';
import { IconView, IconViewSizes, Tooltip } from '@gem/ui-kit';

import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import { useMessageViewsPresenter } from './MessageViews.presenter';
import styles from './MessageViews.styles.m.css';
import { MessageViewsPopover } from './MessageViewsPopover/MessageViewsPopover';
import { MessageViewsStatusIcon } from './MessageViewsStatusIcon/MessageViewsStatusIcon';

interface IMessageViewsProps {
  message: ChatMessage;
  showStatus?: boolean;
  className?: string;
  fixedColor?: boolean;
}

export const MessageViews: FC<IMessageViewsProps> = observer(
  ({ message, className, showStatus = true, fixedColor = false }) => {
    const presenter = useMessageViewsPresenter(message);
    const containerClassName = classNames(styles.container, className, {
      [styles.canShowPointer]: presenter.canBeShowPopover,
      [styles.fixedColor]: fixedColor,
    });

    if (!presenter.isShow) {
      return showStatus ? (
        <MessageViewsStatusIcon
          message={message}
          fixedColor={fixedColor}
        />
      ) : null;
    }

    return (
      <div className={containerClassName}>
        <Tooltip
          render={(tooltip): ReactElement => (
            <MessageViewsPopover
              message={message}
              tooltip={tooltip}
              onOpenReactionPopup={presenter.onOpenReactionPopup}
            />
          )}
          arrow={true}
          delay={300}
          disabled={!presenter.canBeShowPopover}
        >
          <div
            className={styles.content}
            aria-expanded={false}
          >
            <IconView
              Icon={IcView16Icon}
              size={IconViewSizes.Small}
              className={styles.icon}
            />
            <span>{presenter.views}</span>
          </div>
        </Tooltip>
      </div>
    );
  }
);
